import { ListItemText } from "@material-ui/core";

export default ListItemText;
